module.exports = __webpack_public_path__ + "img/5_56.98c84702.png";